import type { IconTileProps } from '@atlaskit/icon/types';

export const APPEARANCES: IconTileProps['appearance'][] = [
	'gray',
	'red',
	'orange',
	'yellow',
	'lime',
	'green',
	'teal',
	'blue',
	'purple',
	'magenta',
];
